module.exports = __webpack_public_path__ + "static/img/karbon.a80dc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tools/karbon.png
// module id = 453
// module chunks = 1